export default __webpack_public_path__ + "static/media/Girdle of Black Spite.6375ff9a.jpg";